import classnames from "classnames"
import parse from "html-react-parser"

import icon from "images/icons/arrow-right.svg?raw"

import styles from "./upgrade_credits_button.module.scss"

interface Props {
  onClick: () => void
  onDark?: boolean
}

const UpgradeCreditsButton = ({ onClick, onDark = false }: Props) => (
  <button
    type="button"
    onClick={onClick}
    className={classnames("button-tertiary button-outlined button-with-icon", styles["upgrade-credits-button"], {
      "button-on-color": onDark,
      [styles["on-dark"]]: onDark,
    })}
  >
    Upgrade for more credits
    <span className="button-icon">{parse(icon)}</span>
  </button>
)

export default UpgradeCreditsButton
